import { render, staticRenderFns } from "./IconSvgPencil.vue?vue&type=template&id=e58e9cd0&scoped=true&"
import script from "./IconSvgPencil.vue?vue&type=script&lang=js&"
export * from "./IconSvgPencil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e58e9cd0",
  null
  
)

export default component.exports